//Área Restrita
import Login from "../views/Auth/Login.jsx";
import EsqueceuSenha from "../views/Auth/EsqueceuSenha.jsx";
import TrocarSenha from "../views/Auth/TrocarSenha.jsx";
import Inicio from "../views/Acompanhamento/Inicio.jsx";
import Dashboard from "../views/Dashboard/Dashboard.jsx";
import ManutencaoForm from "../views/Manutencao/ManutencaoForm.jsx";
import AgendamentoVistoriaLista from "../views/Acompanhamento/AgendamentoVistoriaLista.jsx";
import ExportacaoLauda from "../views/Acompanhamento/ExportacaoLauda.jsx";
import ConsultaCadastro from "../views/Consulta/ConsultaCadastro.jsx";
import ConsultaVeiculo from "../views/Consulta/ConsultaVeiculo.jsx";
import ManutencaoTransportadorLista from "../views/Manutencao/Transportador/ManutencaoTransportadorLista.jsx";
import ManutencaoGeradorLista from "../views/Manutencao/Gerador/ManutencaoGeradorLista.jsx";
import ManutencaoGeradorRSSLista from "../views/Manutencao/GeradorRSS/ManutencaoGeradorRSSLista.jsx";
import ManutencaoGeradorPGRCCLista from "../views/Manutencao/GeradorPGRCC/ManutencaoGeradorPGRCCLista.jsx";
import ManutencaoDestinoLista from "../views/Manutencao/Destino/ManutencaoDestinoLista.jsx";
import CadastroEnquadramento from "../views/Cadastros/CadastroEnquadramento.jsx";
import CadastroDocumentos from "../views/Cadastros/CadastroDocumentos.jsx";
import CadastroSolicitacaoLista from "../views/Cadastros/CadastroSolicitacaoLista.jsx";
import CadastroFluxoLista from "../views/Cadastros/CadastroFluxoLista.jsx";
import CadastroSubPrefeitura from "../views/Cadastros/CadastroSubPrefeitura.jsx";
import CadastroClassesResiduosLista from "../views/Cadastros/CadastroClassesResiduosLista.jsx";
import CadastroSetupAgendaVistoria from "../views/Cadastros/CadastroSetupAgendaVistoria.jsx";
import CadastroDiasNaoUteis from "../views/Cadastros/CadastroDiasNaoUteis.jsx";
import PerfilLista from "../views/Seguranca/PerfilLista.jsx";
import UsuarioLista from "../views/Seguranca/UsuarioLista.jsx";
import RelatoriosLista from "../views/Relatorios/RelatoriosLista.jsx";

// Potal
import PortalOpcoes from "../views/Portal/Opcoes.jsx";
import RequerimentoCancelamento from "../views/Portal/RequerimentoCancelamento.jsx";
import ConsultaRequerimento from "../views/Consulta/ConsultaRequerimento.jsx";
import AnexoComprovantePagamento from "../views/Portal/AnexoComprovantePagamento.jsx";
import AgendamentoVistoriaPortal from "../views/Portal/AgendamentoVistoriaPortal.jsx";
import ImplantacaoDatasys from "../views/Layouts/ImplantacaoDatasys.jsx";
import RequerimentoTaxaFislurb from "../views/Portal/RequerimentoTaxaFislurb.jsx";

// Portal Transportador
import TransportadorRequerimentoNovoCadastro from "../views/Portal/Transportador/RequerimentoNovoCadastro.jsx";
import TransportadorRequerimentoRenovacaoCadastro from "../views/Portal/Transportador/RequerimentoRenovacaoCadastro.jsx";
import TransportadorRequerimentoInclusaoVeiculo from "../views/Portal/Transportador/RequerimentoInclusaoVeiculo.jsx";
import TransportadorRequerimentoExclusaoVeiculo from "../views/Portal/Transportador/RequerimentoExclusaoVeiculo.jsx";
import TransportadorRequerimentoAlteracao from "../views/Portal/Transportador/RequerimentoAlteracao.jsx";
import TransportadorRequerimentoAlteracaoEquipamentos from "../views/Portal/Transportador/RequerimentoAlteracaoEquipamentos.jsx";
import TransportadorRequerimentoAlteracaoIdentificacao from "../views/Portal/Transportador/RequerimentoAlteracaoIdentificacao.jsx";
import TransportadorRequerimentoRenovacaoVeiculo from "views/Portal/Transportador/RequerimentoRenovacaoVeiculo.jsx";
import MeuCadastro from "../views/Portal/MeuCadastro.jsx";

// Portal Gerador
import GeradorRequerimentoNovoCadastro from "../views/Portal/Gerador/RequerimentoNovoCadastro.jsx";
import GeradorRequerimentoRenovacaoCadastro from "../views/Portal/Gerador/RequerimentoRenovacaoCadastro.jsx";
import GeradorRequerimentoInclusaoLocal from "../views/Portal/Gerador/RequerimentoInclusaoLocal.jsx";
import GeradorRequerimentoExclusaoLocal from "../views/Portal/Gerador/RequerimentoExclusaoLocal.jsx";
import GeradorRequerimentoAlteracaoCadastro from "../views/Portal/Gerador/RequerimentoAlteracaoCadastro.jsx";

// Portal Gerador - PGRCC
import GeradorPGRCCRequerimentoNovoCadastro from "../views/Portal/GeradorPGRCC/RequerimentoNovoCadastro.jsx";
import GeradorPGRCCRequerimentoAlteracaoCadastro from "../views/Portal/GeradorPGRCC/RequerimentoAlteracaoCadastro.jsx";
import GeradorPGRCCRequerimentoRenovacaoCadastro from "../views/Portal/GeradorPGRCC/RequerimentoRenovacaoCadastro.jsx";

// Portal Gerador RSS
import GeradorRSSRequerimentoNovoCadastro from "../views/Portal/GeradorRSS/RequerimentoNovoCadastro.jsx";
import GeradorRSSRequerimentoAlteracao from "../views/Portal/GeradorRSS/RequerimentoAlteracao.jsx";

// Portal Destino
import DestinoRequerimentoNovoCadastro from "../views/Portal/Destino/RequerimentoNovoCadastro.jsx";
import DestinoRequerimentoInclusaoLocal from "../views/Portal/Destino/RequerimentoInclusaoLocal.jsx";
import DestinoRequerimentoRenovacao from "../views/Portal/Destino/RequerimentoRenovacaoCadastro.jsx";
import DestinoRequerimentoExclusaoLocal from "../views/Portal/Destino/RequerimentoExclusaoLocal.jsx";
import DestinoRequerimentoAlteracao from "../views/Portal/Destino/RequerimentoAlteracao.jsx";
import DestinoRequerimentoAumentoCapacidade from "../views/Portal/Destino/RequerimentoAumentoCapacidade.jsx";

import Duvidas from "../views/Portal/Duvidas";
import Legislacao from "../views/Portal/Legislacao/index.jsx";
import AtualizarContato from "../views/Shared/AtualizarContato.jsx";

//Carterinhas
import CarteirinhaVeiculo from "../views/Carteirinha/CarteirinhaVeiculo.jsx";
import CarteirinhaGG from "../views/Carteirinha/CarteirinhaGG.jsx";
import CertificadoTransportador from "../views/Carteirinha/CertificadoTransportador.jsx";
import CertificadoRSS from "../views/Carteirinha/CertificadoRSS.jsx";
import CertificadoTransportadorUnificado from "../views/Carteirinha/CertificadoTransportadorUnificado.jsx";
import CertificadoDestino from "../views/Carteirinha/CertificadoDestino.jsx";
import CertificadoDestinoRGG from "../views/Carteirinha/CertificadoDestinoRGG.jsx";
import QrCodeLocalidadeRGG from "../views/Carteirinha/QrCodelocalidadeRGG.jsx";
import CancelamentoRequerimentos from "../views/Shared/CancelamentoRequerimentos.jsx";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "fas fa-chart-line",
    component: Login,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/esqueceusenha",
    name: "EsqueceuSenha",
    icon: "",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/trocarsenha",
    name: "TrocarSenha",
    icon: "",
    component: TrocarSenha,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/inicio",
    name: "Inicio",
    icon: "fas fa-chart-line",
    component: Inicio,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    codigoPermissaoAcesso: "Dashboard",
    icon: "fas fa-file-contract",
    component: Dashboard,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/Manutencao",
    codigoPermissaoAcesso: "Manutencao",
    name: "Manutenção",
    icon: "fas fa-pen",
    component: ManutencaoForm,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/ConsultaCadastro",
    codigoPermissaoAcesso: "ConsultaCadastro",
    name: "Consulta Cadastro",
    icon: "fas fa-search",
    component: ConsultaCadastro,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/ConsultaVeiculos",
    codigoPermissaoAcesso: "ConsultaVeiculo",
    name: "Consulta Veículos",
    icon: "fas fa-car",
    component: ConsultaVeiculo,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CancelamentoRequerimentos",
    codigoPermissaoAcesso: "AnaliseRequerimento",
    name: "Cancelar Requerimentos",
    icon: "fas fa-ban",
    component: CancelamentoRequerimentos,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/AgendamentoVistoria",
    codigoPermissaoAcesso: "AgendaVistoria",
    name: "Agenda de Vistoria",
    icon: "fas fa-calendar-alt",
    component: AgendamentoVistoriaLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/ExportacaoLauda",
    codigoPermissaoAcesso: "ExportacaoLauda",
    name: "Exportação de Lauda",
    icon: "fas fa-file-export",
    component: ExportacaoLauda,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/manutencaotransportador",
    codigoPermissaoAcesso: "Manutencao",
    name: "Manutenção Transportador",
    icon: "fas fa-truck",
    component: ManutencaoTransportadorLista,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/manutencaogerador",
    codigoPermissaoAcesso: "Manutencao",
    name: "Manutenção Gerador",
    icon: "fas fa-store-alt",
    component: ManutencaoGeradorLista,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/manutencaogeradorrss",
    codigoPermissaoAcesso: "Manutencao",
    name: "Manutenção Gerador RSS",
    icon: "fas fa-store-alt",
    component: ManutencaoGeradorRSSLista,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/manutencaogeradorpgrcc",
    codigoPermissaoAcesso: "Manutencao",
    name: "Manutenção Grande Gerador - PGRCC",
    icon: "fas fa-store-alt",
    component: ManutencaoGeradorPGRCCLista,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/manutencaodestino",
    codigoPermissaoAcesso: "Manutencao",
    name: "Manutenção Destino Final",
    icon: "fas fa-store-alt",
    component: ManutencaoDestinoLista,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/CadastroEnquadramento",
    codigoPermissaoAcesso: "CadastroEnquadramento",
    name: "Enquadramentos",
    icon: "fas fa-puzzle-piece",
    component: CadastroEnquadramento,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroDocumentos",
    codigoPermissaoAcesso: "CadastroDocumentos",
    name: "Documentos",
    icon: "fas fa-file-alt",
    component: CadastroDocumentos,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroSolicitacao",
    codigoPermissaoAcesso: "CadastroSolicitacao",
    name: "Configuração Solicitação",
    icon: "fas fa-cog",
    component: CadastroSolicitacaoLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroFluxo",
    codigoPermissaoAcesso: "CadastroFluxo",
    name: "Fluxo de Cadastro",
    icon: "fas fa-sitemap",
    component: CadastroFluxoLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroSubPrefeitura",
    codigoPermissaoAcesso: "CadastroSubPrefeitura",
    name: "SubPrefeitura",
    icon: "fas fa-university",
    component: CadastroSubPrefeitura,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroClassesResiduos",
    codigoPermissaoAcesso: "CadastroClassesResiduos",
    name: "Classes e Resíduos",
    icon: "fas fa-recycle",
    component: CadastroClassesResiduosLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroSetupAgendaVistoria",
    codigoPermissaoAcesso: "SetupAgenda",
    name: "Setup Agenda",
    icon: "fas fa-calendar",
    component: CadastroSetupAgendaVistoria,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/CadastroDiasNaoUteis",
    codigoPermissaoAcesso: "CadastroDiasNaoUteis",
    name: "Dias Não Úteis",
    icon: "far fa-calendar-times",
    component: CadastroDiasNaoUteis,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/Perfis",
    codigoPermissaoAcesso: "Perfis",
    name: "Cadastro de Perfil",
    icon: "fas fa-users",
    component: PerfilLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/Usuarios",
    codigoPermissaoAcesso: "Usuarios",
    name: "Cadastro de Usuários",
    icon: "fas fa-user",
    component: UsuarioLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/Relatorios",
    codigoPermissaoAcesso: "Relatorios",
    name: "Relatórios",
    icon: "fas fa-file-alt",
    component: RelatoriosLista,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "/Opcoes",
    name: "Opções",
    component: PortalOpcoes,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/duvidas",
    name: "Duvidas",
    component: Duvidas,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/legislacoes",
    name: "Legislação",
    component: Legislacao,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimento",
    name: "Transportador",
    component: TransportadorRequerimentoNovoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoRenovacao",
    name: "Transportador",
    component: TransportadorRequerimentoRenovacaoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoInclusaoVeiculo",
    name: "Transportador",
    component: TransportadorRequerimentoInclusaoVeiculo,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoExclusaoVeiculo",
    name: "Transportador",
    component: TransportadorRequerimentoExclusaoVeiculo,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoAlteracao",
    name: "Transportador",
    component: TransportadorRequerimentoAlteracao,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoAlteracaoIdentificacao",
    name: "Transportador",
    component: TransportadorRequerimentoAlteracaoIdentificacao,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/AtualizarContato",
    name: "Atualizar Contato",
    component: AtualizarContato,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoAlteracaoEquipamentos",
    name: "Transportador",
    component: TransportadorRequerimentoAlteracaoEquipamentos,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/TransportadorRequerimentoRenovacaoVeiculo",
    name: "Transportador",
    component: TransportadorRequerimentoRenovacaoVeiculo,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/MeuCadastro",
    name: "Meu Cadastro",
    component: MeuCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/ConsultaRequerimento",
    name: "Consulta de Requerimento",
    icon: "fas fa-search",
    component: ConsultaRequerimento,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/CarteirinhaVeiculo",
    name: "Carteirinha",
    icon: "",
    component: CarteirinhaVeiculo,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/GeradorRequerimento",
    name: "Gerador",
    component: GeradorRequerimentoNovoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorRequerimentoRenovacao",
    name: "Gerador",
    component: GeradorRequerimentoRenovacaoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorRequerimentoInclusaoLocal",
    name: "Gerador",
    component: GeradorRequerimentoInclusaoLocal,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorRequerimentoExclusaoLocal",
    name: "Gerador",
    component: GeradorRequerimentoExclusaoLocal,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorRequerimentoAlteracaoCadastro",
    name: "Gerador",
    component: GeradorRequerimentoAlteracaoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/CarteirinhaGG",
    name: "Carteirinha",
    icon: "",
    component: CarteirinhaGG,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/QrCodelocalidadeRGG",
    name: "Carteirinha",
    icon: "",
    component: QrCodeLocalidadeRGG,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/GeradorRSSRequerimento",
    name: "Gerador",
    component: GeradorRSSRequerimentoNovoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorPGRCCRequerimento",
    name: "Gerador",
    component: GeradorPGRCCRequerimentoNovoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorRSSRequerimentoAlteracao",
    name: "Gerador",
    component: GeradorRSSRequerimentoAlteracao,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/DestinoRequerimento",
    name: "Destino",
    component: DestinoRequerimentoNovoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/DestinoRequerimentoInclusaoLocal",
    name: "Destino",
    component: DestinoRequerimentoInclusaoLocal,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/DestinoRequerimentoRenovacao",
    name: "Destino",
    component: DestinoRequerimentoRenovacao,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/DestinoRequerimentoExclusaoLocal",
    name: "Destino",
    component: DestinoRequerimentoExclusaoLocal,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/DestinoRequerimentoAlteracao",
    name: "Destino",
    component: DestinoRequerimentoAlteracao,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/DestinoRequerimentoAumentoCapacidade",
    name: "Destino",
    component: DestinoRequerimentoAumentoCapacidade,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/CertificadoRSS",
    name: "CertificadoRSS",
    icon: "",
    component: CertificadoRSS,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/CertificadoTransportador",
    name: "CertificadoTransportador",
    icon: "",
    component: CertificadoTransportador,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/CertificadoTransportadorUnificado",
    name: "CertificadoTransportadorUnificado",
    icon: "",
    component: CertificadoTransportadorUnificado,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/CertificadoDestino",
    name: "CertificadoDestino",
    icon: "",
    component: CertificadoDestino,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/CateirinhaDestinoRGG",
    name: "CertificadoDestinoRGG",
    icon: "",
    component: CertificadoDestinoRGG,
    layout: "/Empty",
    sidebar: false,
  },
  {
    path: "/RequerimentoCancelamento",
    name: "Cancelamento",
    component: RequerimentoCancelamento,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/ComprovantePagamento",
    name: "Comprovante de Pagamento",
    icon: "",
    component: AnexoComprovantePagamento,
    layout: "/external",
    sidebar: false,
  },
  {
    path: "/AgendamentoVistoria",
    name: "Agendamento de Vistoria",
    icon: "",
    component: AgendamentoVistoriaPortal,
    layout: "/external",
    sidebar: false,
  },
  {
    path: "/prototipo",
    name: "Implantação Datasys",
    icon: "",
    component: ImplantacaoDatasys,
    layout: "/external",
    sidebar: false,
  },
  {
    path: "/GeradorPGRCCRequerimentoAlteracaoCadastro",
    name: "Gerador",
    component: GeradorPGRCCRequerimentoAlteracaoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/GeradorPGRCCRequerimentoRenovacaoCadastro",
    name: "Gerador",
    component: GeradorPGRCCRequerimentoRenovacaoCadastro,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/RequerimentoTaxaFislurb",
    name: "Gerador",
    component: RequerimentoTaxaFislurb,
    layout: "/auth",
    sidebar: false,
  },
];
export default routes;
